import React, {useState} from "react"
import TermsAndConditions from "../../terms/components/TermsAndConditions"
import PrivacyPolicy from "../../terms/components/PrivacyPolicy"
import {Grid, LinearProgress, Typography, withStyles} from "material-ui"
import {bool, func, shape, string} from "prop-types"
import compose from "recompose/compose"
import moment from 'moment'
import CheckCircleIcon from 'material-ui-icons/CheckCircle'
import FaceIcon from 'material-ui-icons/Face'
import HomeIcon from 'material-ui-icons/Home'
import DateRangeIcon from 'material-ui-icons/DateRange'
import ScheduleIcon from 'material-ui-icons/Schedule'
import MonetizationOnIcon from 'material-ui-icons/MonetizationOn'
import StorageIcon from 'material-ui-icons/Storage'
import ShoppingCartIcon from 'material-ui-icons/ShoppingCart'

import {formatNumber} from "../../../common/format"
import Check from "../../flow/components/check"
import config from "../../../config"
import {Button} from "../../../components"

const styles = theme => ({
  body: {
    display: 'flex',
    justifyContent: 'center',
    padding: 16
  },
  termsTYCContainer: {
    maxWidth: 700
  },
  logo: {
    width: 220,
    marginBottom: 16,
    padding: '60px 0',
    '@media (max-width: 700px)': {
      width: 110,
      padding: '30px 0',
    },
  },
  loadingContainer: {
    height: 5,
    width: '100%',
    position: 'absolute',
    top: 0
  },
  paperContainer: {
    height: 'calc(100vh - 211px)',
    minHeight: 360,
    maxWidth: 820,
    '@media (max-width: 700px)': {
      height: 'calc(100vh - 102px)',
    },
  },
  container: {
    minHeight: 550,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    width: '100%',
    margin: 'auto',
    padding: '15px 25px',
    boxShadow: theme.shadows[2],
    borderRadius: 2,
    '@media (min-width: 960px)': {
      margin: 'auto',
    },
  },
  titleContainer: {
    margin: 0,
    paddingBottom: 20,
  },
  title: {
    fontSize: 24
  },
  item: {
    borderBottom: 'solid 1px #dcdcdc',
    margin: 0
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  label: {
    alignItems: 'center',
  },
  valueContainer: {},
  amountContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  amountSecondary: {
    color: '#a5a5a5',
  },
  amount: {
    marginTop: 3,
    paddingTop: 3,
    borderTop: 'solid 1px #dcdcdc',
  },
  icon: {
    marginRight: 10,
  },
  navigator: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: 'auto',
  },
  buttonContainer: {
    flex: 1,
    textAlign: 'center',
  },
  endButton: {
    display: 'none',
    '@media (min-width: 768px)': {
      display: 'block',
    },
  },
  errorTerms: {
    color: 'red',
  },
  thankYouTitle: {
    fontSize: 24,
    color: theme.palette.primary.main,
    textAlign: 'center'
  },
  thankYouDescription: {
    marginTop: 20,
  }
})


const TermsDeposit = ({classes, token, userID, enableButton, acceptTC, successTC, verifyEmail, deposit, ...otherProps}) => {
  const { loadingDeposit, loadingEmail, loadingTC, errorDeposit, errorTC } = otherProps

  const [acceptedTC, setAcceptedTC] = useState(false)
  const [acceptTCError, setAcceptTCError] = useState(false)

  const { operation_number, full_address_string, items, datetime, total_storage_cost, transport_cost, type, cubic_m, time_interval } = deposit
  const totalCost = total_storage_cost + transport_cost

  const ServiceType = () => type === 'm3'
    ? <Typography variant="body2" color="primary">m<sup>3</sup></Typography>
    : <Typography variant="body2" color="primary">{type}</Typography>

  const confirmTC = () => {
    if (!acceptedTC) return setAcceptTCError('Por favor, necesitamos que leas y aceptes los términos y condiciones, haciendo click en la casilla de arriba, para poder confirmar el retiro de tus cosas.')
    setAcceptTCError('')
    verifyEmail(token)
    acceptTC(token)
  }

  const totalQuantityItems = items.reduce((acc, i) => acc + i.amount, 0)

  return (
    <div className={classes.body}>
      <div className={classes.loadingContainer}>
        {(loadingDeposit || loadingEmail || loadingTC) && <LinearProgress/>}
      </div>
      <Grid container spacing={0} justify="center" className={classes.termsTYCContainer}>
        <Grid container item xs={12} justify="center" alignItems="center">
          <img className={classes.logo} src="/assets/logo/2.png" alt="Space Guru"/>
        </Grid>
        {(successTC && !loadingEmail) && (
          <Grid item>
            <Typography className={classes.thankYouTitle}>¡Gracias!</Typography>
            <Typography className={classes.thankYouDescription}>¡Felicitaciones! ¡Tu espacio en Space Guru ya está reservado!</Typography>
          </Grid>
        )}
        {(!loadingDeposit && !successTC && !errorDeposit) && (
          <React.Fragment>
            <Grid container item xs={12} className={classes.titleContainer}>
              <Typography className={classes.title}>Detalles del retiro</Typography>
            </Grid>
            <Grid container item spacing={3} className={classes.content}>
              <Grid item container className={classes.item}>
                <Grid item xs={6} className={classes.labelContainer}>
                  <CheckCircleIcon className={classes.icon} fontSize="small"/>
                  <Typography variant="body2" className={classes.label}>Operación</Typography>
                </Grid>
                <Grid item xs={6} className={classes.valueContainer}>
                  <Typography variant="body2" color="primary">#{operation_number}</Typography>
                </Grid>
              </Grid>
              <Grid item container className={classes.item}>
                <Grid item xs={6} className={classes.labelContainer}>
                  <FaceIcon className={classes.icon} fontSize="small"/>
                  <Typography variant="body2">Número de cliente</Typography>
                </Grid>
                <Grid item xs={6} className={classes.valueContainer}>
                  <Typography variant="body2" color="primary">{userID}</Typography>
                </Grid>
              </Grid>
              <Grid item container className={classes.item}>
                <Grid item xs={6} className={classes.labelContainer}>
                  <HomeIcon className={classes.icon} fontSize="small"/>
                  <Typography variant="body2">Dirección de retiro</Typography>
                </Grid>
                <Grid item xs={6} className={classes.valueContainer}>
                  <Typography variant="body2" color="primary">{full_address_string}</Typography>
                </Grid>
              </Grid>
              <Grid item container className={classes.item}>
                <Grid item xs={6} className={classes.labelContainer}>
                  <DateRangeIcon className={classes.icon} fontSize="small"/>
                  <Typography variant="body2">Fecha de retiro</Typography>
                </Grid>
                <Grid item xs={6} className={classes.valueContainer}>
                  <Typography variant="body2" color="primary">
                    {moment(datetime).format('LL')}<br/>
                  </Typography>
                </Grid>
              </Grid>
              <Grid item container className={classes.item}>
                <Grid item xs={6} className={classes.labelContainer}>
                  <ScheduleIcon className={classes.icon} fontSize="small"/>
                  <Typography variant="body2">Franja Horaria de Retiro:</Typography>
                </Grid>
                <Grid item xs={6} className={classes.valueContainer}>
                  <Typography variant="body2" color="primary">{time_interval}</Typography>
                </Grid>
              </Grid>
              <Grid item container className={classes.item}>
                <Grid item xs={6} className={classes.labelContainer}>
                  <StorageIcon className={classes.icon} fontSize="small"/>
                  <Typography variant="body2">Tipo de servicio</Typography>
                </Grid>
                <Grid item xs={6} className={classes.valueContainer}>
                  <ServiceType/>
                </Grid>
              </Grid>
              {type === 'm3' && (
                <Grid item container className={classes.item}>
                  <Grid item xs={6} className={classes.labelContainer}>
                    <ShoppingCartIcon className={classes.icon} fontSize="small"/>
                    <Typography variant="body2">Cantidad</Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.valueContainer}>
                    <Typography variant="body2" color="primary">{cubic_m} m<sup>3</sup></Typography>
                  </Grid>
                </Grid>
              )}
              {type === 'items' && (
                <Grid item container className={classes.item}>
                  <Grid item xs={6} className={classes.labelContainer}>
                    <ShoppingCartIcon className={classes.icon} fontSize="small"/>
                    <Typography variant="body2">Cantidad</Typography>
                  </Grid>
                  <Grid item xs={6} className={classes.valueContainer}>
                    {items.map(i => (
                      <Typography variant="body2" className={classes.amountSecondary}>
                        {i.description} - Cantidad {i.amount}
                      </Typography>
                    ))}
                    <Typography variant="body2" color="primary" className={classes.amount}>{totalQuantityItems} Item{totalQuantityItems > 1 && 's'}</Typography>
                  </Grid>
                </Grid>
              )}
              <Grid item container className={classes.item}>
                <Grid item xs={6} className={classes.labelContainer}>
                  <MonetizationOnIcon className={classes.icon} fontSize="small"/>
                  <Typography variant="body2">Monto</Typography>
                </Grid>
                <Grid item xs={6} className={classes.amountContainer}>
                  <Typography variant="body2" className={classes.amountSecondary}>
                    ${formatNumber(total_storage_cost)} - guardado mensual
                  </Typography>
                  <Typography variant="body2" className={classes.amountSecondary}>
                    ${formatNumber(transport_cost)} - flete
                  </Typography>
                  <Typography variant="body2" color="primary" className={classes.amount}>
                    ${formatNumber(totalCost)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid container item>
              <Grid item style={{ margin: 0, marginTop: 20, width: 'inherit' }}>
                <Typography>Por favor, corroborá que la información proporcionada esté correcta, leé nuestros Términos y Condiciones y confirmá debajo haciendo click en el botón "Confirmar".</Typography>
              </Grid>
              <Grid item style={{ margin: 0, marginTop: 20, width: 'inherit', display: 'flex', alignItems: 'center' }}>
                <Check checked={acceptedTC} onChange={() => {
                  setAcceptedTC(!acceptedTC)
                  setAcceptTCError('')
                }} style={{padding: 0}}/>
                <Typography>Confirmo que he leído y aceptado los <a rel="noopener noreferrer" href={config.LANDING_URL + '/terms.html'} target='_blank'>Términos y Condiciones</a> de Space Guru.</Typography>
              </Grid>
              {acceptTCError &&
              <Grid item style={{width: 'inherit'}}>
                <Typography className={classes.errorTerms}>{acceptTCError}</Typography>
              </Grid>
              }
              {errorTC &&
                <Grid item style={{width: 'inherit'}}>
                  <Typography className={classes.errorTerms}>{errorTC}</Typography>
                </Grid>
              }
              <Grid item style={{width: 'inherit', display: 'flex', justifyContent: 'center'}}>
                <Button disabled={loadingEmail || loadingTC} onClick={confirmTC}>Confirmar</Button>
              </Grid>
            </Grid>
          </React.Fragment>
        )}
        {errorDeposit &&
        <Grid item style={{width: 'inherit'}}>
          <Typography className={classes.errorTerms}>{errorDeposit}</Typography>
        </Grid>
        }
      </Grid>
    </div>
  )
}

TermsDeposit.propTypes = {
  match: shape({
    params: shape({
      code: string,
    }).isRequired,
  }).isRequired,
  classes: shape({}),
  code: string.isRequired,
  accepted: bool.isRequired,
  acceptedTC: bool.isRequired,
  acceptedPrivacy: bool.isRequired,
  loadingTerms: bool.isRequired,
  loadingAccept: bool.isRequired,
  disabledButton: bool.isRequired,
  enableButton: func.isRequired,
  acceptTC: func.isRequired,
  verifyAcceptance: func.isRequired,
  acceptPrivacy: func.isRequired,
  errorTerms: string,
  error: string,
}

export default compose(withStyles(styles, {withTheme: true}))(TermsDeposit)



// WEBPACK FOOTER //
// ./src/sections/termsDeposit/components/TermsDeposit.js